import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import './index.css';
import App from './App';

// Register the MUI X (Pro) licence once, before any DataGridPro mounts. The key is
// version-bound to the 8.x line (see package.json pins). A missing key only renders a
// watermark — nothing breaks — so this is safe to run empty in dev/foundation. NEVER
// hardcode a key here; it comes from VITE_MUI_X_LICENSE_KEY at build time.
//
// The name must match .env exactly. This previously read VITE_MUI_LICENSE_KEY while
// .env defined VITE_MUI_X_LICENSE_KEY, so the key resolved to '' and the watermark
// showed even on builds where the key was present.
const muiLicenseKey = import.meta.env.VITE_MUI_X_LICENSE_KEY ?? '';
LicenseInfo.setLicenseKey(muiLicenseKey);
if (!muiLicenseKey) {
  // Warn in production too: a silent empty key is exactly how the watermark
  // survived to a customer demo.
  console.warn(
    '[MUI X] VITE_MUI_X_LICENSE_KEY is not set — DataGridPro will show a licence watermark.',
  );
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('No #root element in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
